import { StoreInterface } from '@/stores/store';
import { UserStatus } from '@/typings/backend';
import { StateCreator } from 'zustand';

export type StatusSlice = {
  userStatus: UserStatus;
  setUserStatus: (status: UserStatus) => void;
};

export const createStatusSlice: StateCreator<StoreInterface, [], [], StatusSlice> = (set) => ({
  userStatus: UserStatus.ONLINE,

  setUserStatus: (status) => set({ userStatus: status }),
});
